__turbopack_context__.v({
  "cards": "r_2B7W_cards",
  "skeletonCard": "r_2B7W_skeletonCard",
});
